import { useState, useCallback } from 'react';
import type { Language } from '../i18n/translations';

const LANGUAGE_KEY = 'interfaceLang';

function loadLanguage(): Language {
  try {
    const raw = localStorage.getItem(LANGUAGE_KEY);
    if (raw === 'en' || raw === 'ru' || raw === 'pl') {
      return raw;
    }
  } catch (e) {
    console.warn('Failed to read language from localStorage', e);
  }
  return 'en';
}

export function useLanguage() {
  const [language, setLanguageState] = useState<Language>(loadLanguage);

  const setLanguage = useCallback((next: Language) => {
    setLanguageState(next);
    try {
      localStorage.setItem(LANGUAGE_KEY, next);
    } catch (e) {
      console.warn('Failed to save language to localStorage', e);
    }
  }, []);

  return { language, setLanguage } as const;
}
